/** Fire-and-forget async work without the `void` operator (Sonar S3735). */
export function runDetached(promise: Promise<unknown>): void {
  Promise.resolve(promise).catch(() => undefined)
}
